import styled from 'styled-components';
import { breakpoint } from 'constants/breakpoints';

export const TipsPageWrapper = styled.div`
    max-width: 1280px;
    margin: 50px auto 0;
    padding: 0 15px 40px;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    box-sizing: border-box;

    @media screen and ${breakpoint.S} {
        padding: 0;
        margin: 0;
    }
`;

export const HighlightTipWrapper = styled.div`
    height: 100%;
    flex: 1 2 468px;
    box-shadow: 0 5px 25px #cdd6f2;
    border-radius: 5px;

    .lighter {
        color: #333;
    }

    @media screen and ${breakpoint.S} {
        border-radius: 0;
        box-shadow: none;
        max-width: 100%;
        overflow: hidden;
    }
`;

export const HighlightImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;

    @media screen and ${breakpoint.S} {
        border-radius: 0;
    }
`;
export const HighlightContent = styled.div`
    padding: 40px 45px;

    iframe {
        max-width: 100%;
    }

    @media screen and ${breakpoint.S} {
        iframe {
            max-height: 200px !important;
        }
        padding: 20px;
    }
`;

export const TipsListWrapper = styled.div`
    flex: 1 2 312px;

    @media screen and ${breakpoint.S} {
        padding: 20px 0;
        border-top: 1px solid #e7f6ef;
        max-width: calc(100% - 40px);
        margin: 0 auto;
    }
`;

export const TabsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    gap: 15px;
    border-radius: 5px;
    margin-bottom: 20px;

    & button {
        flex: 1 1 0;
    }
`;

export const TipsListContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

export const TipsItemWrapper = styled.div`
    box-shadow: 0 5px 25px #cdd6f2;
    border-radius: 5px;
    height: 130px;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    gap: 20px;
    cursor: pointer;
    transition: transform 0.3s ease-in-out;
    transform: scale(1);

    &:hover {
        transform: scale(1.01);
    }

    @media screen and ${breakpoint.M} {
        flex-direction: column;
        height: auto;
        gap: 0;
    }
`;

export const TipsItemImage = styled.div`
    flex: 1 1 40%;
    min-width: 230px;

    img {
        border-radius: 5px;
    }

    @media screen and ${breakpoint.M} {
        min-width: auto;
    }
`;

export const TipsItemContent = styled.div`
    flex: 1 1 60%;
    @media screen and ${breakpoint.M} {
        padding: 0 10px;
    }
`;

export const TermsWrapper = styled.div`
    padding: 10px 40px;
    box-sizing: content-box;
    background: #edf1f8;
    border-radius: 5px;
    margin: 0 auto;
    font: normal 16px/18px 'Roboto Condensed';

    @media screen and ${breakpoint.S} {
        padding: 10px 20px;
    }
`;
